import { useMutation } from '@tanstack/react-query';
import { LoginApi } from '../../../apis/LoginApi/LoginApi.ts';

export function usePostForgotPasswordMutation() {
    return useMutation<string, Error, { mail: string }>({
        mutationFn: async ({ mail }) => {
            return LoginApi.forgotPassword(mail);
        },
    });
}
